import { CopyButton } from '@/_shared/components/CopyButton';

/**
 * ACT2-1124: a copied Redshift IAM account works only after the role's trust policy accepts the sibling's id as well
 * as the original workspace's, because Lookout and RudderStack assume the role with the id of the workspace that runs
 * them. The server builds the condition with both ids.
 */
export function IamTrustPolicyNotice({
  message,
  condition,
}: {
  message: string;
  condition: string;
}): React.ReactElement {
  return (
    <div className="grid gap-2">
      <p className="text-sm text-foreground">{message}</p>
      <div className="flex items-start gap-2">
        <pre className="min-w-0 flex-1 overflow-x-auto rounded-lg bg-muted p-3 font-mono text-xs whitespace-pre text-foreground">
          {condition}
        </pre>
        <CopyButton text={condition} label="Copy" copyLabel="Trust policy condition" />
      </div>
    </div>
  );
}
